module.exports = __webpack_public_path__ + "img/fx6.4c37ef9b.webp";